import { FC, useState } from 'react';

interface PreviewableImageProps {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    className?: string;
    title?: string;
    previewClassName?: string;
}

const PreviewableImage: FC<PreviewableImageProps> = ({
    src,
    alt,
    width = 24,
    height = 24,
    className = "inline-block",
    title = "Click to preview",
    previewClassName = "max-w-4xl max-h-full"
}) => {
    const [previewImage, setPreviewImage] = useState<string | null>(null);

    return (
        <>
            <img
                src={src}
                alt={alt}
                width={width}
                height={height}
                className={`${className} cursor-pointer hover:opacity-80 transition-opacity`}
                onClick={() => setPreviewImage(src)}
                title={title}
            />

            {/* Image Preview Modal */}
            {previewImage && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
                    onClick={() => setPreviewImage(null)}
                >
                    <div className={`relative ${previewClassName}`}>
                        <img
                            src={previewImage}
                            alt="Preview"
                            className="max-w-full max-h-full object-contain rounded-lg"
                            onClick={(e) => e.stopPropagation()}
                        />
                        <button
                            onClick={() => setPreviewImage(null)}
                            className="absolute top-4 right-4 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 rounded-full w-10 h-10 flex items-center justify-center transition-all"
                            title="Close preview"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default PreviewableImage;
